<template>
  <div id="app">
    <div class="view-container">
      <HeaderComponent v-if="route == 'login' || route == 'signup'"></HeaderComponent>
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>
    <NavbarComponent v-if="route !== 'login' && route !== 'signup'"></NavbarComponent>
  </div>
</template>

<script>

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import NavbarComponent from '@/components/NavbarComponent'
import HeaderComponent from '@/components/HeaderComponent'
import globalStyle from '@/assets/style/global.css'

// import { Pagination, Button, Layout, TooltipPlugin, FormPlugin } from 'bootstrap-vue/es/components'
// import bTooltipD from 'bootstrap-vue/es/directives/tooltip/tooltip'

// [Pagination, Button, Layout, FormPlugin, TooltipPlugin, globalStyle].forEach(comp => {
//   Vue.use(comp)
// })
// Vue.directive('b-tooltip', bTooltipD)

Vue.use(BootstrapVue, globalStyle)

export default {
  name: 'app',
  components: {
    NavbarComponent,
    HeaderComponent
  },

  data () {
    return {
      transitionName: ''
    }
  },
  watch: {
    $route (to, from) {
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  },
  computed: {
    route () {
      return this.$route.name
    }
  }
}
</script>

<style>
  body {
    overflow: hidden;
    font-family: Source Sans Pro, sans-serif;

  }
  #app {
    height: 100%;
    margin: 0;
  }
  .view-container {
    height: auto;
  }
  /* Slide Transition */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
/* End slide transtion */

</style>



// WEBPACK FOOTER //
// src/App.vue